export default __webpack_public_path__ + "static/media/heart.07d8dc5f.svg";